import { jsxs as o, jsx as s } from "react/jsx-runtime";
import { c as n } from "../../../index-Cu0xwYjD.js";
import { VisuallyHidden as c } from "../VisuallyHidden/VisuallyHidden.js";
import '../../../assets/Spinner.css';const m = "_wrapper_5lex6_3", _ = "_spinner_5lex6_7", d = "_spin_5lex6_7", x = "_inverted_5lex6_19", r = {
  wrapper: m,
  spinner: _,
  spin: d,
  inverted: x
}, i = {
  small: "3rem",
  large: "6rem"
}, w = ({
  size: e = "small",
  inverted: p = !1,
  accessibilityLabel: t = "Loading",
  className: a
}) => {
  const l = e in i ? i[e] : e;
  return /* @__PURE__ */ o(
    "div",
    {
      style: { "--spinner-size": l },
      className: n(r.wrapper, a),
      role: "alert",
      "aria-busy": "true",
      children: [
        /* @__PURE__ */ s(
          "div",
          {
            className: n(r.spinner, { [r.inverted]: p })
          }
        ),
        /* @__PURE__ */ s(c, { children: t })
      ]
    }
  );
};
export {
  w as Spinner,
  i as semanticSizes
};
